/**
 * Global auth interceptor - signs user out on invalid/expired JWT (401/403).
 * Only triggers when the user is actually logged in (has qtcid_ cookie).
 * Most customer-fe pages are public and don't require login, so we skip
 * logout for unauthenticated visitors.
 * Import this file once in App.js as a side-effect.
 */
import axios from "axios";
import cookie from "react-cookies";

// Flag to prevent multiple logout redirects
let isLoggingOut = false;

function handleAuthFailure() {
  // Only sign out if the user is actually logged in
  if (!cookie.load("qtcid_")) return;
  if (isLoggingOut) return;
  isLoggingOut = true;

  // Clear auth cookies
  cookie.remove("qtcid_", { path: "/" });
  cookie.remove("usr-id-qt", { path: "/" });
  cookie.remove("quotetoken", { path: "/" });
  cookie.remove("currentOrder", { path: "/" });

  // Redirect to home page
  window.location.href = "/";
}

// Axios global interceptor - catches 401/403 on authenticated calls
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      handleAuthFailure();
    }
    return Promise.reject(error);
  }
);

// Patch global fetch - catches 401/403 on authenticated calls
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (response.status === 401 || response.status === 403) {
    handleAuthFailure();
  }
  return response;
};
